'use strict';

var GridRemoveSpecialEventButtonDirective = function GridRemoveSpecialEventButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-remove-special-event-button.html'),
    controller: 'GridRemoveSpecialEventButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
GridRemoveSpecialEventButtonDirective.$inject = [];
module.exports = GridRemoveSpecialEventButtonDirective;